import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,

  mixins: [reactiveProp],

  props: {
    showLegend: {
      type: Boolean,
      default: false
    },
    legendPosition: {
      type: String,
      default: "top",
      validator: function(value) {
        // The chartValuemust match one of these strings
        return ["bottom", "top", "left", "right"].includes(value);
      }
    },
    yAxesTicksMin: {
      type: Number,
      default: undefined
    },
    yAxesTicksMax: {
      type: Number,
      default: undefined
    },
    yAxesTicksSuggestedMax: {
      type: Number,
      default: 5
    },
    yAxesTicksStepSize: {
      type: Number,
      default: 1
    },
    yAxesTicksPadding: {
      type: Number,
      default: null
    },
    yAxesTicksFontColor: {
      type: String,
      default: undefined
    },
    yAxesGridLinesBorders: {
      type: Boolean,
      default: true
    },
    xAxesTicksPadding: {
      type: Number,
      default: null
    },
    xAxesTicksFontColor: {
      type: String,
      default: undefined
    },
    xAxesTicksOffset: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend,
          position: this.legendPosition,
          labels: {
            fontFamily: "Lato, sans-serif",
            fontSize: 16
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontFamily: "Lato, sans-serif",
                beginAtZero: true,
                min: this.yAxesTicksMin,
                max: this.yAxesTicksMax,
                stepSize: this.yAxesTicksStepSize,
                padding: this.yAxesTicksPadding,
                fontColor: this.yAxesTicksFontColor,
                suggestedMax: this.yAxesTicksSuggestedMax,
                callback: function(value) {
                  return Math.abs(value) > 999
                    ? Math.sign(value) * (Math.abs(value) / 1000).toFixed(1) +
                        "k"
                    : Math.sign(value) * Math.abs(value);
                }
              },
              gridLines: {
                drawBorder: this.yAxesGridLinesBorders
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                padding: this.xAxesTicksPadding,
                fontColor: this.xAxesTicksFontColor
              },
              ticks: {
                fontFamily: "Lato, sans-serif"
              },
              offset: this.xAxesTicksOffset
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || "";
              if (label && label === "Sleep") {
                label += ": ";
                let chartValue = tooltipItem.yLabel;
                if (chartValue % 1 === 0) {
                  return label + chartValue + " hours 0 minutes";
                } else {
                  let chartValue = tooltipItem.yLabel;
                  let hours = Math.floor(chartValue);
                  let min = Math.floor(
                    (chartValue - Math.floor(chartValue)) * 60
                  );
                  let combined = hours + " hours " + min + " minutes";
                  return label + combined;
                }
              } else {
                //  round and add thousandths separator to number
                label += ": ";
                label += tooltipItem.yLabel
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return label;
              }
            }
          }
        }
      }
    };
  },

  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
